var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChimney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159 140H75V120C75 114.48 80.376 110 87 110H147C153.624 110 159 114.48 159 120V140Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159 240H75V130H159V240Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 136,
    width: 20,
    height: 9,
    fill: "#AFAFAF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 197,
    width: 21,
    height: 8,
    fill: "#999999"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 145,
    width: 21,
    height: 8,
    fill: "#AFAFAF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 205,
    width: 17,
    height: 9,
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 36C169.09 36 172 33.0899 172 29.5C172 25.9101 169.09 23 165.5 23C161.91 23 159 25.9101 159 29.5C159 33.0899 161.91 36 165.5 36Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150 23C152.761 23 155 20.7614 155 18C155 15.2386 152.761 13 150 13C147.239 13 145 15.2386 145 18C145 20.7614 147.239 23 150 23Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 9C164.985 9 167 6.98528 167 4.5C167 2.01472 164.985 0 162.5 0C160.015 0 158 2.01472 158 4.5C158 6.98528 160.015 9 162.5 9Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153 89C161.837 89 169 82.0604 169 73.5C169 64.9396 161.837 58 153 58C144.163 58 137 64.9396 137 73.5C137 82.0604 144.163 89 153 89Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 81C155.508 81 162 73.6127 162 64.5C162 55.3873 155.508 48 147.5 48C139.492 48 133 55.3873 133 64.5C133 73.6127 139.492 81 147.5 81Z",
    fill: "url(#paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 68C138.717 68 147 58.8218 147 47.5C147 36.1782 138.717 27 128.5 27C118.283 27 110 36.1782 110 47.5C110 58.8218 118.283 68 128.5 68Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131 95C140.941 95 149 86.7173 149 76.5C149 66.2827 140.941 58 131 58C121.059 58 113 66.2827 113 76.5C113 86.7173 121.059 95 131 95Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 92.5,
    y1: 88.5,
    x2: 178.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C0C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979FA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChimney);
export default __webpack_public_path__ + "static/media/chimney.31d894b2d64ebec9573efe500c4c4912.svg";
export { ForwardRef as ReactComponent };